import MonitorUtils, { MONITORING_COLLECTOR_TYPE } from 'utils/MonitorUtils';

interface IHighMarginTracking {
  sku: string;
  sellerId: string;
  productId: string;
  pathname: string;
  resultPage?: string;
}

const mapPage: { [key: string]: string } = {
  products: 'product-list',
  'product/[slug]': 'product-detail-page',
  'quick-order': 'quick-order',
  cart: 'cart',
  substitutes: 'substitute-products-listing',
};

const buildMetadata = ({ sku, sellerId, productId, pathname, resultPage }: IHighMarginTracking) => ({
  sku,
  sellerId,
  productId,
  screen: mapPage?.[pathname.replace('/', '')] || pathname,
  platform: 'web',
  resultPage: resultPage || '',
});

const useTrackingMonitorHighMargin = () => {
  const trackingHighMarginImpression = (input: IHighMarginTracking) =>
    MonitorUtils.highMarginProductEvent(MONITORING_COLLECTOR_TYPE.HIGH_MARGIN_PRODUCT_IMPRESSION, buildMetadata(input));
  const trackingHighMarginClickDetail = (input: IHighMarginTracking) =>
    MonitorUtils.highMarginProductEvent(MONITORING_COLLECTOR_TYPE.HIGH_MARGIN_PRODUCT_CLICK_DETAIL, buildMetadata(input));
  const trackingHighMarginAddToCart = (input: IHighMarginTracking) =>
    MonitorUtils.highMarginProductEvent(MONITORING_COLLECTOR_TYPE.HIGH_MARGIN_PRODUCT_ADD_TO_CART, buildMetadata(input));

  return { trackingHighMarginImpression, trackingHighMarginClickDetail, trackingHighMarginAddToCart };
};

export default useTrackingMonitorHighMargin;
